// @ts-nocheck
import React from 'react';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

export function CustomerTagDistributionChart({ data }) {
  if (!data || data.length === 0) {
    return (
      <div className="bg-white p-4 rounded-lg shadow">
        <p className="text-center text-gray-500">データがありません</p>
      </div>
    );
  }

  // カラーパレット（タグ数に応じて動的に生成）
  const generateColors = (count) => {
    const baseColors = [
      'rgb(59, 130, 246)',   // blue
      'rgb(16, 185, 129)',   // green
      'rgb(251, 146, 60)',   // orange
      'rgb(239, 68, 68)',    // red
      'rgb(168, 85, 247)',   // purple
      'rgb(236, 72, 153)',   // pink
      'rgb(14, 165, 233)',   // sky
      'rgb(34, 197, 94)',    // emerald
      'rgb(251, 191, 36)',   // amber
      'rgb(156, 163, 175)',  // gray
    ];
    
    // 必要に応じて色を繰り返す
    const colors = [];
    for (let i = 0; i < count; i++) {
      colors.push(baseColors[i % baseColors.length]);
    }
    return colors;
  };

  const chartData = {
    labels: data.map(d => d.tag),
    datasets: [
      {
        label: '顧客数',
        data: data.map(d => d.count),
        backgroundColor: generateColors(data.length),
        borderWidth: 1
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'right' as const
      },
      title: {
        display: true,
        text: '顧客タグ別分布'
      }
    }
  };

  return (
    <div className="bg-white p-4 rounded-lg shadow">
      <div style={{ height: '300px' }}>
        <Pie data={chartData} options={options} />
      </div>
    </div>
  );
}
